module.exports = __webpack_public_path__ + "static/img/topButton3.c2b0018a.png";